import { Mic, MicOff } from 'lucide-react';
import { useVoice } from '@/hooks/useVoice';

export default function VoiceInput({ onResult, fieldType = 'text', className = '' }) {
  const { isListening, startListening, stopListening, isSupported, error } = useVoice();

  const handleClick = () => {
    if (isListening) {
      stopListening();
      return;
    }
    startListening(onResult, fieldType);
  };

  if (!isSupported) {
    return (
      <button
        type="button"
        disabled
        title="Voice input requires Chrome or Edge"
        className="p-2 rounded-lg text-[#4A5568] cursor-not-allowed opacity-50"
        data-testid="voice-input-unsupported"
      >
        <MicOff size={16} />
      </button>
    );
  }

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={handleClick}
        className={`p-2 rounded-lg transition-all ${isListening ? 'text-[#EF4444] animate-pulse' : 'text-[#4A5568] hover:text-[#E2E8F0]'}`}
        title={isListening ? 'Stop listening' : 'Start voice input'}
        data-testid="voice-input-btn"
      >
        <Mic size={16} />
      </button>
      {isListening && <span className="absolute -bottom-5 left-0 text-[10px] text-[#EF4444] font-mono whitespace-nowrap">Listening…</span>}
      {error && <span className="absolute -bottom-5 left-0 text-[10px] text-[#EF4444] font-mono whitespace-nowrap">{error}</span>}
    </div>
  );
}
